import { render, staticRenderFns } from "./BotCard.vue?vue&type=template&id=5b71f38e&scoped=true&"
import script from "./BotCard.vue?vue&type=script&lang=js&"
export * from "./BotCard.vue?vue&type=script&lang=js&"
import style0 from "./BotCard.vue?vue&type=style&index=0&id=5b71f38e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71f38e",
  null
  
)

export default component.exports